var fsApiKeyStock = '32b865a69e92dd04c10786593beef991';
const storeStockChecker = async () => {
    let trigger = document.querySelector('#store-product-stock-value');
    if (trigger == null || typeof trigger == 'undefined') {
        window.setTimeout(storeStockChecker, 350);
        return;
    }

    //
    trigger.addEventListener('click', async () => {
        document.querySelector('.pickup-availability-button.button-link.button-link--medium').click();
        return;
        let selectedVariant = document.querySelector('.main-product__form-form input[name="id"]').value;
        let response = await fetch(`https://kave-home-singapore.myshopify.com/api/2024-04/graphql.json`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': fsApiKey,
            },
            body: JSON.stringify({
                query: `query getProductById($id: ID!) {
                    product(id: $id) {
                        handle
                        title
                        variants(first: 15) {
                            edges {
                                node {
                                    id
                                    storeAvailability(first: 10) {
                                        edges {
                                            node {
                                                quantityAvailable
                                                available
                                                location {
                                                    name
                                                    address {
                                                        address1
                                                        city
                                                        country
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }`,
                variables: {
                    id: 'gid://shopify/Product/' + document.querySelector('#store-product-stock-value').getAttribute('data-product-id')
                }
            })
        })
        .then(response => response.json())
        .then(response => {
            console.info("@@@", response);
        });
    });
};

storeStockChecker();